<div class="modal-header">
  <h3 class="modal-title">Identity verification</h3>
</div>

<form (submit)="verify()">
  <div class="modal-body">
    @if (chosenMethod() === undefined) {
      <div class="d-flex flex-column align-items-center justify-content-center my-4">
        <div
          class="spinner-border text-colour-blue-600"
          style="width: 3rem; height: 3rem;"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    } @else {
      <h2>Please verify your identity</h2>
      <p>
        @switch (true) {
          @case (isEmailBased()) {
            To access this functionality within Legal & General Ignite, you will need to verify your identity by
            entering the 6 digit code
            we have sent to your email address.
          }
          @case (isAppBased()) {
            To access this functionality within Legal & General Ignite, you will need to verify your identity by
            entering the 6 digit code
            from your authenticator app.
          }
        }
      </p>

      <div class="mt-3">
        <label
          class="fw-bold"
          for="twoFactorVerification_verificationCode"
        >
          6 digit code
        </label>
        <div class="row">
          <div class="col-7">
            <input
              type="text"
              class="form-control"
              maxlength="6"
              id="twoFactorVerification_verificationCode"
              data-testid="twoFactorVerification_verificationCode"
              [class.is-invalid]="isCodeInvalid"
              [formControl]="verificationCode"
            >
          </div>
        </div>
      </div>

      @if (codeFailedValidation) {
        <div class="row">
          <div class="col-7">
            <div class="alert alert-danger alert-danger-icon mt-2 mb-0">
              <span>
                @switch (true) {
                  @case (isEmailBased() && requiresNewVerificationCode()) {
                    Too many unsuccessful attempts.
                    @if (canRequestVerificationCodeIn() > 0) {
                      Please wait {{canRequestVerificationCodeIn()}} seconds to resend code.
                    } @else {
                      Please
                      <a
                        href="javascript:void(0)"
                        class="text-colour-red-800 lg-link"
                        data-testid="twoFactorVerification_resendCode"
                        (click)="requestVerification()"
                      >
                        resend code
                      </a>.
                    }
                  }

                  @case (isEmailBased()) {
                    Verification unsuccessful.
                    @if (canRequestVerificationCodeIn() > 0) {
                      Please try again or wait {{canRequestVerificationCodeIn()}} seconds to resend code.
                    } @else {
                      Please try again or
                      <a
                        href="javascript:void(0)"
                        class="text-colour-red-800 lg-link"
                        data-testid="twoFactorVerification_resendCode"
                        (click)="requestVerification()"
                      >
                        resend code
                      </a>.
                    }
                  }

                  @case (canAttemptVerificationIn() > 0) {
                    Too many unsuccessful attempts.
                    Please try again in {{canAttemptVerificationIn()}} seconds.
                  }

                  @default {
                    Verification unsuccessful. Please try again.
                  }
                }
              </span>
            </div>
          </div>
        </div>

      } @else if (verificationCode.touched && verificationCode.invalid) {
        <div class="row">
          <div class="col-7">
            <div class="alert alert-danger alert-danger-icon mt-2 mb-0">
              <span>
                Verification code {{verificationCode.errors?.['required'] ? 'is required' : 'should be a 6-digit number'}}.
              </span>
            </div>
          </div>
        </div>
      }

      @if (isEmailBased() && !codeFailedValidation) {
        <p class="mt-3 mb-1">
          @if (canRequestVerificationCodeIn() > 0) {
            Please wait {{canRequestVerificationCodeIn()}} seconds to resend code.
          } @else {
            <a
              href="javascript:void(0)"
              class="lg-link"
              data-testid="twoFactorVerification_resendCode"
              (click)="requestVerification()"
            >
              Resend code
            </a>
          }
        </p>
      }

      @if (isAppBased()) {
        <p class="mt-3 mb-1">
          Don't have access to your authenticator app?
        </p>
        <p class="mt-1 mb-4">
          <a
            href="javascript:void(0)"
            class="lg-link"
            data-testid="twoFactorVerification_requestEmail"
            (click)="useEmail()"
          >
            Request your code to be sent to your Ignite registered email.
          </a>
        </p>
      }

      <div class="form-check mt-3">
        <input
          type="checkbox"
          class="form-check-input"
          id="twoFactorVerification_rememberMe"
          data-testid="twoFactorVerification_rememberMe"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="rememberMe"
        >
        <label
          class="form-check-label fw-bold"
          for="twoFactorVerification_rememberMe"
        >
          Remember me on this device
        </label>
      </div>
      <p class="text-muted m-0">Not recommended if you are using a shared device</p>
    }
  </div>

  <div class="modal-footer">
    <button
      type="submit"
      class="btn btn-colour-blue-600"
      data-testid="twoFactorVerification_verify"
      [disabled]="chosenMethod() === undefined"
    >
      Verify
    </button>
  </div>
</form>
